module.exports = __webpack_public_path__ + "img/materials_jp.3d7b7f5.jpg";